const emptyArray = <T>(array: T[]): boolean => !array.length;

const notEmptyArray = <T>(array: T[]): boolean => !emptyArray(array);

export { emptyArray, notEmptyArray };
